import { ProcessingFile } from '@dealstack/frontend/shared/components/Documents/types';
import { FindRelatedFilesRes } from '@dealstack/shared/lib/generated';

/**
 * Whether finishing the "manage file associations" step would actually change anything.
 *
 * an all-duplicate batch with nothing ticked is a no-op. Completing it would upload no
 * files, create no links, and still show "upload successful". Continue is disabled instead — the
 * user exits via Cancel, or follows the link through to the document that already holds the file.
 */
export const canCompleteFileAssociationStep = ({
	relatedFiles,
	processingFiles,
	hasUploadEntity,
}: {
	relatedFiles: FindRelatedFilesRes[] | undefined;
	processingFiles: ProcessingFile[];
	hasUploadEntity: boolean;
}): boolean => {
	if (!relatedFiles?.length) {
		return true;
	}

	// A deal directory upload always links the duplicate to the entity it started from, so there
	// is always work to do.
	if (hasUploadEntity) {
		return true;
	}

	const hasFileToUpload = processingFiles.some(
		(processingFile) =>
			!relatedFiles.some(
				(relatedFile) =>
					relatedFile.md5 === processingFile.md5 &&
					relatedFile.matchedDocuments.length > 0
			)
	);

	if (hasFileToUpload) {
		return true;
	}

	return relatedFiles.some((relatedFile) =>
		relatedFile.relatedTransactions.some((relatedTransaction) => relatedTransaction.shouldLink)
	);
};
